<template>
  <div>
    <BaseTitle :title="$t('menu.assignment_score')" :yearPeriode="titleData" />
    <div>
      <v-row>
        <v-col cols="12" md="8" class="py-0 mb-2">
          <div class="move-list">
            <div class="move-list-title pa-5">
              <div class="d-flex justify-space-between align-center">
                <span
                  >{{ studentData.assignmentTitle }}<br />
                  {{ $t('content.due_date') }} : {{ studentData.dueDate }} <span v-if="!studentData.dueDate">-</span> <br />
                  {{ $t('content.name_teacher') }} : {{ studentData.teacherName }} <span v-if="!studentData.teacherName">-</span> </span
                ><span>
                  <span class="mr-8 pointer" @click="studentFrom">{{ equal }}</span>
                  {{ index + 1 }} / {{ quizStudent.length }} {{ $t('content.student') }}
                  <span class="ml-8 pointer" @click="studentTo">></span>
                </span>
              </div>
            </div>
            <div class="move-list-content">
              <ul class="pa-2">
                <v-card class="mb-5" v-for="(quizQuestions, idx) in studentData.quizQuestions" :key="quizQuestions.quizQuestionId">
                  <template>
                    <div class="pa-1 d-flex justiy-space-between align-items section-header active">
                      <div class="text-right student-title mr-1">{{ $t('question.question') }} {{ quizQuestions.quizQuestionNo }}</div>
                      <v-spacer />
                      <li>
                        <span class=" student-title mr-2"> {{ $t('content.score') }} : </span>
                        <div style="width: 50px">
                          <v-text-field
                            type="number"
                            dark
                            color="white"
                            min="0"
                            v-model="quizQuestions.score"
                            @input="maximum({ $event, quizQuestions, idx })"
                            v-number
                            class="shrink mx-1"
                          ></v-text-field>
                        </div>
                        <span class="student-title">{{ $t('form.from') }} {{ quizQuestions.outOf }}</span>
                      </li>
                    </div>
                  </template>
                  <template>
                    <div class="assignment-content">
                      <div class="mt-6">
                        <!-- <p>
                          {{ quizQuestions.quizQuestion }}
                        </p> -->
                        <article v-if="quizQuestions.quizQuestion" class="container mb-5" v-html="quizQuestions.quizQuestion" />
                        <span v-else>-</span>

                        <img
                          :src="quizQuestions.imageUrl"
                          style="
                      width : 50%;
                      height : 30%;
                      flex: 1;
                    "
                        />
                      </div>
                      <div class="ml-3" v-if="quizQuestions.quizTypeId === 1">
                        <v-radio-group v-model="quizQuestions.studentAnswers[0].studentAnwer">
                          <v-radio
                            class="pa-2 compact-form"
                            v-for="radio in quizQuestions.quizAnswers"
                            v-bind:key="radio.quizAnswerId"
                            :label="`${radio.quizAnswer} ${$t(radio.correctAnswer ? 'content.correct_answer' : '')}`"
                            disabled
                            :value="radio.quizAnswerId"
                            color="info"
                          >
                          </v-radio>
                        </v-radio-group>
                      </div>
                      <div class="ml-3" v-if="quizQuestions.quizTypeId === 2">
                        <v-checkbox
                          color="info"
                          class="compact-form"
                          v-for="radio in quizQuestions.quizAnswers"
                          v-bind:key="radio.quizAnswerId"
                          disabled
                          v-model="quizQuestions.answerMultiple"
                          :label="`${radio.quizAnswer} ${$t(radio.correctAnswer ? 'content.correct_answer' : '')}`"
                          :value="radio.quizAnswerId"
                        />
                      </div>
                      <div class="ml-3" v-if="quizQuestions.quizTypeId === 3">
                        <div v-if="quizQuestions.studentAnswers[0].studentAnwer" class="pa-5">
                          <article v-if="quizQuestions.studentAnswers[0].studentAnwer" v-html="quizQuestions.studentAnswers[0].studentAnwer" />
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="ml-3" v-if="quizQuestions.quizTypeId === 4">
                        <v-text-field
                          class="compact-form"
                          v-for="(radio, idx) in quizQuestions.studentAnswers"
                          v-bind:key="idx"
                          disabled
                          v-model="radio.studentAnwer"
                          :label="
                            `${$t('content.your_answer')} ${$t(radio.correct === true && radio.bySystem === true ? 'content.correct' : '')} ${$t(
                              radio.correct === true && radio.bySystem === true ? 'content.correct_answer' : ''
                            )} ${radio.answer} `
                          "
                        />
                      </div>
                      <div class="ml-3" v-if="quizQuestions.quizTypeId === 5">
                        <v-text-field
                          class="compact-form"
                          v-for="(radio, idx) in quizQuestions.studentAnswers"
                          v-bind:key="idx"
                          disabled
                          v-model="radio.studentAnwer"
                          :label="`${$t('content.your_answer')} ${$t('content.is')} ${$t(radio.correct ? 'content.correct' : 'content.incorrect')} `"
                        />
                      </div>
                    </div>
                  </template>
                </v-card>
              </ul>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="py-0">
          <div class="move-list">
            <div class="move-list-title d-flex justify-center pa-7">
              <svg-icon icon="ic-profile" width="21px" height="22px" class="mr-2" /> <span class="mt-1">{{ studentData.fullName }}</span>
              <div class="text-center ml-3">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <span dark v-bind="attrs" v-on="on">
                      <svg-icon icon="ic-moreaction-white" class="mt-1" />
                    </span>
                  </template>
                  <v-list>
                    <v-list-item v-for="(item, index) in quizStudent" :key="index">
                      <v-list-item-title class="text-dropdown" @click="updateKey(index)">{{ item.fullName }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
            <div class="move-list-content">
              <ul>
                <span class="text-right"> {{ $t('content.submitted') }}: </span>
                <li style="color : #F7B500">{{ studentData.submittedDate }}</li>
              </ul>
              <ul>
                <span class="text-right"> {{ $t('content.assignment_type') }} : </span>
                <li>{{ $t('content.assignment_item.quiz') }}</li>
              </ul>
              <ul>
                <span class="text-right"> {{ $t('content.raw_score') }} : </span>
                <li>{{ studentData.rawScore }}</li>
              </ul>
              <ul>
                <span class="text-right"> {{ $t('content.status_scoring') }} : </span>
                <li v-if="studentData.complete === true">{{ $t('content.complete') }}</li>
                <li v-if="studentData.complete === false">{{ $t('content.incomplete') }}</li>
              </ul>
              <ul>
                <span class="text-right"> {{ $t('content.adjustment') }}: : </span>
                <li><v-text-field type="number" min="0" v-model="studentData.adjustmentScore" v-number :label="$t('content.score')" /></li>
              </ul>

              <ul>
                <span class="text-right"> {{ $t('content.score') }}: </span>
                <li>{{ studentData.rawScore }} {{ $t('form.from') }} {{ studentData.outOf }}</li>
              </ul>

              <ul>
                <span class="text-right"> {{ $t('content.comments') }}: </span>
                <li>
                  <text-editor v-model="studentData.comment" />
                </li>
              </ul>
              <hr />

              <div class="d-flex justify-end align-center">
                <v-btn color="primary" class="btn-primary-custom mr-3 mt-10" outlined @click="back">{{ $t('back') }}</v-btn>
                <v-btn color="primary" class="btn-primary-custom mt-10" type="submit" @click="submit" :loading="loading">
                  {{ $t('submit') }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-col>
        <v-btn v-scroll="onScroll" v-show="fab" fab dark fixed bottom right color="blue" @click="toTop">
          <v-icon>
            mdi-menu-up
          </v-icon>
        </v-btn>
        <!-- Dialog Success -->
        <v-dialog v-model="dialogPopUp" persistent max-width="800">
          <v-card>
            <div class="d-flex justify-center">
              <svg-icon icon="img-success" class="succ-featured pa-10" width="860" height="300" />
            </div>
            <v-card-title class="headline d-flex justify-center">{{ $t('success.add_assignment_score_quiz') }} </v-card-title>
            <v-card-text class="d-flex justify-center">{{ $t('success.add_assignment_content_score_quiz') }} </v-card-text>
            <v-card-text class="d-flex justify-center">
              <v-btn color="primary" class="btn-primary-custom" @click="dialogPopUp = false">
                {{ $t('close') }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import TextEditor from '@/components/base/TextEditor.vue';

export default {
  name: 'TeacherAssignmentScoreQuiz',
  components: {
    BaseTitle,
    TextEditor
  },
  computed: {
    ...mapGetters({
      tokenBearer: 'Auth/token',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    equal() {
      return '<';
    }
  },
  data: () => ({
    loading: false,
    dialogPopUp: false,
    checkbox: false,
    radioGroup: '',
    answer: '',
    description: '',
    dataClass: '',
    baseUrl: process.env.VUE_APP_BASE_URL,
    quizStudent: '',
    studentData: {},
    index: 0,
    fab: false,
    config: {
      theme: 'dark',
      imageAllowedTypes: ['jpeg', 'jpg', 'png'],
      events: {
        'image.beforeUpload': function(files) {
          var editor = this;
          if (files.length) {
            var reader = new FileReader();
            reader.onload = function(e) {
              var result = e.target.result;
              editor.image.insert(result, null, null, editor.image.get());
            };
            reader.readAsDataURL(files[0]);
          }
          editor.popups.hideAll();
          return false;
        }
      }
    },
    titleData: ''
  }),
  methods: {
    maximum(e) {
      if (Number(e.$event) > Number(e.quizQuestions.outOf)) {
        this.$nextTick(() => {
          this.studentData.quizQuestions[e.idx].score = e.quizQuestions.outOf;
        });
      }
    },
    onScroll(e) {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    studentFrom() {
      if (this.index > 0) {
        this.index = this.index - 1;
        this.studentData = this.quizStudent?.[this.index];
      }
    },
    studentTo() {
      if (this.quizStudent.length - 1 > this.index) {
        this.index = this.index + 1;
        this.studentData = this.quizStudent?.[this.index];
      }
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getData() {
      var assignmentId = this.$route.params.assignmentId;
      this.$store
        .dispatch('Assignment/quizStudentScoreQuiz', { assignmentId })
        .then(res => {
          res.forEach(form =>
            form.quizQuestions.forEach(data => {
              if (data.quizTypeId === 4) {
                var string = data.quizQuestion;
                var number = 0;

                data.quizQuestion = string.replaceAll('(?)', function() {
                  return '(' + ++number + ')';
                });
              }
              data.studentAnswers.forEach(resa => {
                if (data.quizTypeId === 1) {
                  resa.studentAnwer = parseInt(resa.studentAnwer);
                }
                if (data.quizTypeId === 2) {
                  let dataQuiz = data.studentAnswers.reduce((acc, row) => {
                    acc.push(parseInt(row.studentAnwer));
                    return acc;
                  }, []);
                  data.answerMultiple = dataQuiz;
                }
              });
            })
          );
          if (this.index == 0) {
            this.studentData = res?.[0];
          } else {
            this.studentData = res?.[this.index];
          }
          this.quizStudent = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    updateKey(key) {
      this.studentData = null;
      this.studentData = this.quizStudent?.[key];
      this.index = key;
    },
    back() {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'TeacherAssignmentDetail' });
      } else {
        this.$router.push({ name: 'TeacherAssignmentSectionDetail' });
      }
    },
    submit() {
      // this.dialogPopUp = true;
      var assignmentId = this.$route.params.assignmentId;
      var data = this.studentData;
      var json = { ...data, assignmentId };
      this.loading = true;
      this.$store
        .dispatch(`Assignment/saveScoringQuiz`, json)
        .then(() => {
          this.$store.dispatch('general/showSuccessNotification', { message: 'Success' });
          this.studentTo();
          this.getData();
          // this.$router.push({ name: 'TeacherGrupAssignmentSuccessScoreFile' });
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    }
  },
  created() {
    this.getData();
    this.getDataClass();
  }
};
</script>

<style lang="scss" scoped>
.compact-form {
  transform: scale(0.875);
  transform-origin: left;
}
.pointer {
  cursor: pointer;
}
.move-list {
  height: 100%;

  &-title {
    background: #00bf63;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    border-radius: 8px 8px 0 0;
    padding: 10px;
    width: 100%;
  }

  &-content {
    border: 1px solid #d8d8d8;
    border-radius: 0 0 8px 8px;
    padding: 10px;
    background: #fff;
    overflow: scroll;
    overflow-x: hidden;
    width: 100%;
    height: 100%;
    line-height: 2em;

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;
        padding: 10px 15px;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
.text-dropdown {
  cursor: pointer;
}

.text-right {
  display: flex;
  justify-content: space-between;
  margin-left: 15px;
  margin-top: 10px;
  align-items: center;
  font-weight: bold;
}
.viewer {
  @extend %overlay;
  color: #fff;
  display: flex;
  flex-direction: column;
  z-index: 200;

  &-bar {
    display: flex;
    align-items: center;
    padding: 20px;
    background: rgba($color: #000000, $alpha: 0.5);
  }

  &-content {
    height: 800px;
    flex-basis: 100%;
    border: none;
  }
}

.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f3fc;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }
}
.assignment {
  &-title {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #acacac;
  }

  &-icon {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background: #fff0da;
    color: #f1b65a;
    box-sizing: border-box;
    text-align: center;
    margin-right: 16px;

    svg {
      transform: scale(1.6);
      margin-top: 15px;
    }
  }

  &-content {
    margin: 10px 20px 20px 20px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.6);
    font-family: Montserrat;
    line-height: 20px;
    text-align: left;
  }
  &-desc {
    line-height: 1.8em;
    padding-left: 65px;
  }
}

.section-header {
  border-radius: 8px 8px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 13px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.input__label {
  color: #ffffff;
}
</style>
